import { Link } from "react-router-dom";
import { AccountMenu } from "@/components/AccountMenu";
import { Save, Download, ChevronLeft, Loader2, ChevronDown, Link2 } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";

export const StudioHeader = ({ name, onName, dirty, saving, exporting, onSave, onExport, canExport, isDemo, homeTo, onShare }) => (
  <header data-testid="app-header" className="h-16 px-6 border-b border-[#352d40] bg-[#0f0d11]/90 backdrop-blur-md sticky top-0 z-50 flex items-center gap-5">
    <Link to={homeTo} data-testid="btn-open-projects" className="flex items-center gap-2 text-stone-400 hover:text-amber-200 transition-colors">
      <ChevronLeft size={16} />
      <span className="font-gothic text-lg tracking-[0.15em] text-amber-100/90">VOX <span className="text-[#c92a3e]">✦</span> NOCTURNA</span>
    </Link>
    <span className="h-6 w-px bg-[#352d40]" />
    <input
      data-testid="project-name-input"
      value={name}
      onChange={(e) => onName(e.target.value)}
      className="bg-transparent font-cormorant italic text-xl text-stone-200 outline-none border-b border-transparent focus:border-[#D99B43] min-w-0 flex-1 max-w-sm transition-colors"
    />
    <span className="eyebrow hidden md:inline" data-testid="save-status">{isDemo ? "Public demo · read-only" : saving ? "Sealing…" : dirty ? "Unsaved" : "Sealed in the vault"}</span>
    <span className="flex-1" />
    <button data-testid="btn-save-project" onClick={onSave} disabled={saving} className="btn-gothic">
      {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} {isDemo ? "Save a copy" : "Save"}
    </button>
    {!isDemo && (
      <button data-testid="btn-share-mix" onClick={onShare} disabled={!canExport} className="btn-gothic">
        <Link2 size={14} /> Share
      </button>
    )}
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={!canExport || exporting}>
        <button data-testid="btn-export-wav" className="btn-crimson">
          {exporting ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} Export WAV <ChevronDown size={12} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#141018] border-[#5a1e28] rounded-none">
        <DropdownMenuItem data-testid="export-full-mix" onSelect={() => onExport(false)} className="font-mono-vox text-xs uppercase tracking-[0.15em]">Full mix</DropdownMenuItem>
        <DropdownMenuItem data-testid="export-vocals-only" onSelect={() => onExport(true)} className="font-mono-vox text-xs uppercase tracking-[0.15em]">Vocals only (no song)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
    <AccountMenu />
  </header>
);
